<template>
  <component :is="component" />
</template>

<script>
import hightendMakePlanOrderCheck from '../components/hightendMakePlanOrderCheck.vue'
import hightendMakePlanOrder from '../hightendMakePlanOrder.vue'
export default {
  components: {
    hightendMakePlanOrderCheck,
    hightendMakePlanOrder
  },
  data() {
    return {
      component: 'hightendMakePlanOrderCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'hightendMakePlanOrderCheck' : 'hightendMakePlanOrder'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/make-plan-manage/check/hightendMakePlanOrderCheck.vue